import { AuthStore } from '@common/store/auth.store';
import React, { FC, PropsWithChildren } from 'react';
import NoFound from '../NoFound';

export const PublicRoute: FC<PropsWithChildren> = ({ children }) => {
  const isAuthenticated = AuthStore((state) => state.isAuthenticated);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return !isAuthenticated ? <>{children}</> : <NoFound />;
};
